<template>
    <article class="kpi-card">
        <header class="kpi-card-head">
            <span class="kpi-card-label">{{ meta.label }}</span>
            <span
                v-if="meta.description"
                class="kpi-card-info"
                :title="meta.description"
            >
                <i class="fal fa-info-circle"></i>
            </span>
        </header>
        <div class="kpi-card-value">{{ formatted }}</div>
    </article>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { formatMetricValue } from '@/helpers/metricFormat'

export default {
    name: 'KpiCardWidget',
    props: {
        meta: { type: Object, required: true },
        value: { default: null }
    },
    computed: {
        formatted() {
            const locale = (this.$i18n && this.$i18n.locale) || 'fr-FR'
            return formatMetricValue(this.value, this.meta.unit, locale)
        }
    }
}
</script>

<style scoped>
.kpi-card {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 120px;
    transition: border-color var(--v2-transition-fast), box-shadow var(--v2-transition-fast);
}

.kpi-card:hover {
    border-color: var(--v2-border-strong);
    box-shadow: var(--v2-shadow-sm);
}

.kpi-card-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
}

.kpi-card-label {
    font-size: 0.78rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-3);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    line-height: 1.3;
}

.kpi-card-info {
    color: var(--v2-text-4);
    font-size: 0.85rem;
    cursor: help;
    flex-shrink: 0;
}

.kpi-card-info i {
    color: inherit !important;
}

.kpi-card-value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 2.4rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.1;
    font-variant-numeric: tabular-nums;
}
</style>
